import { OutBoundReferralItem, Referral, ReferralDto, ReferralListItem } from 'types/referrals';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIReferralsSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['Referrals', 'ReferralsListItems', 'OutBoundReferrals'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getReferralById: builder.query<Referral, string>({
                query: (entityId) => `v1/referrals/${entityId}`,
                keepUnusedDataFor: 0,
                providesTags: (_1, _2, arg) => [{ type: 'Referrals', id: arg }],
            }),
            getReferralsWithFilters: accumulatedQueryWithFilters<ReferralListItem>(builder, '/v1/referrals', {
                providesTags: ['ReferralsListItems'],
            }),
            getOutBoundReferralsWithFilters: accumulatedQueryWithFilters<OutBoundReferralItem>(
                builder,
                '/v1/referrals/outbound',
                {
                    providesTags: ['OutBoundReferrals'],
                }
            ),
            addReferral: builder.mutation<Referral, ReferralDto>({
                query: ({ ...body }) => ({
                    url: '/v1/referrals',
                    method: 'POST',
                    body,
                }),
                invalidatesTags: ['Referrals', 'ReferralsListItems', 'OutBoundReferrals'],
            }),
            updateReferral: builder.mutation<Referral, ReferralDto>({
                query: ({ id, ...body }) => ({
                    url: `/v1/referrals/${id}`,
                    method: 'PUT',
                    body,
                }),
                invalidatesTags: (_1, _2, arg) =>
                    arg.id
                        ? ['Referrals', 'ReferralsListItems', 'OutBoundReferrals', { type: 'Referrals', id: arg.id }]
                        : ['Referrals', 'ReferralsListItems', 'OutBoundReferrals'],
            }),
            deleteReferral: builder.mutation<boolean, { id: string }>({
                query: ({ id }) => ({
                    url: `/v1/referrals/${id}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['Referrals', 'ReferralsListItems', 'OutBoundReferrals'],
            }),
        }),
    });

export const {
    useGetReferralByIdQuery,
    useLazyGetReferralsWithFiltersQuery,
    useLazyGetOutBoundReferralsWithFiltersQuery,
    useAddReferralMutation,
    useUpdateReferralMutation,
    useDeleteReferralMutation,
} = APIReferralsSlice;
